define([
    "angular",
    "../../../../arrays/arrays",
    "lodash",
    "../../../hereMapsModule"
], function (angular, arrays, _, mapsModule) {
    "use strict";

    return mapsModule.service("nlgMarkerHereMapsService", [
        "$rootScope",
        "hereMapsService",
        "hereMapsMarkersFactory",
        function ($rootScope,
                  hereMapsService,
                  hereMapsMarkersFactory) {
            var Here = null;
            var selectedIcon = null;
            var defaultIcon = null;

            return {
                toggleMarkers: toggleVisibleMarkers,
                toggleMarkersByModel: toggleMarkersByModel,
                selectAllMapMarkers: selectAllMapMarkers,
                cleanSelection: cleanSelection,
                getBoundingBoxOfSelectedMarkers: getBoundingBoxOfSelectedMarkers
            };

            function toggleMarkersByModel(markersModel) {
                var clusterMarkers = hereMapsMarkersFactory.getClusterMarkers();
                var markersToChangeIcon = [];
                var dataPoints = [];
                _.forEach(markersModel, function (markerModel) {
                    var id = markerModel.data.id;
                    var markerHere = clusterMarkers.noiseMarkersById[id];
                    if (markerHere) {
                        markersToChangeIcon.push(markerHere);
                    } else {
                        var clusterMarker = clusterMarkers.clusterMarkersById[id];
                        dataPoints.push(clusterMarker);
                    }

                });
                toggleVisibleMarkers(markersToChangeIcon);
                toggleModelsOnly(dataPoints);
            }

            function toggleVisibleMarkers(markers) {
                _.forEach(markers, function (markerHere) {
                    var noisePointData = markerHere.getData();
                    var markerModel = noisePointData.getData();
                    if (isSelected(markerModel)) {
                        setDefaultIcon(markerHere, markerModel);
                        arrays.remove($rootScope.selectedHereMapsMarkersModel, markerModel);
                        return;
                    }
                    setSelectedIcon(markerHere, markerModel);
                    $rootScope.selectedHereMapsMarkersModel.push(markerModel);
                });
            }

            function toggleModelsOnly(dataPoints) {
                _.forEach(dataPoints, function (dataPoint) {
                    var markerModel = dataPoint.getData();
                    if (isSelected(markerModel)) {
                        arrays.remove($rootScope.selectedHereMapsMarkersModel, markerModel);
                        return;
                    }
                    $rootScope.selectedHereMapsMarkersModel.push(markerModel);
                });
            }

            function selectAllMapMarkers(markers) {
                var clusterMarkers = hereMapsMarkersFactory.getClusterMarkers();
                _.forEach(markers, function (markerModel) {
                    if (isSelected(markerModel)) {
                        return;
                    }
                    var markerHere = clusterMarkers.noiseMarkersById[markerModel.id];
                    if (markerHere) {
                        setSelectedIcon(markerHere, markerModel);
                    }
                    $rootScope.selectedHereMapsMarkersModel.push(markerModel);
                });
            }

            function cleanSelection() {
                var copy = arrays.copy($rootScope.selectedHereMapsMarkersModel);
                var clusterMarkers = hereMapsMarkersFactory.getClusterMarkers();
                _.forEach(copy, function (markerModel) {
                    var markerHere = clusterMarkers.noiseMarkersById[markerModel.id];
                    if (markerHere) {
                        setDefaultIcon(markerHere, markerModel);
                    }
                    arrays.remove($rootScope.selectedHereMapsMarkersModel, markerModel);
                });
            }

            function getBoundingBoxOfSelectedMarkers() {
                if (!Here) {
                    Here = hereMapsService.getHere();
                }
                return new Here.geo.MultiPoint(getCoordsOfSelectedMarkers()).getBoundingBox();
            }


            function getCoordsOfSelectedMarkers() {
                return arrays.map($rootScope.selectedHereMapsMarkersModel, function (markerModel) {
                    return {
                        lat: markerModel.geographicInfo.latitude,
                        lng: markerModel.geographicInfo.longitude
                    };
                });
            }

            function isSelected(marker) {
                return arrays.contains($rootScope.selectedHereMapsMarkersModel, marker);
            }

            function setSelectedIcon(markerHere, markerModel) {
                markerHere.setIcon(getSelectedIconToMarkerHere());
                markerModel.icon = selectedIconToMarkerHere();
            }

            function getSelectedIconToMarkerHere() {
                if (!Here) {
                    Here = hereMapsService.getHere();
                }
                if (!selectedIcon) {
                    selectedIcon = new Here.map.Icon(selectedIconToMarkerHere(), {
                        anchor: {x: 16, y: 32}
                    });
                }
                return selectedIcon;
            }

            function setDefaultIcon(markerHere, markerModel) {
                markerHere.setIcon(getDefaultIconToMarkerHere());
                markerModel.icon = defaultIconToMarkerHere();
            }

            function getDefaultIconToMarkerHere() {
                if (!Here) {
                    Here = hereMapsService.getHere();
                }
                if (!defaultIcon) {
                    defaultIcon = new Here.map.Icon(defaultIconToMarkerHere(), {
                        anchor: {x: 16, y: 32}
                    });
                }
                return defaultIcon;
            }

            function selectedIconToMarkerHere() {
                return "images/marker-pin-check.png";
            }

            function defaultIconToMarkerHere() {
                return "images/marker-pin.png";
            }


        }]
    );
});